import React from 'react'
import { Button, Typography, useDimensions } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'
import { usePatientPlanType } from 'hooks/usePatientPlanType'

import PrivacyLockImage from 'static/images/free-and-privacy-disclaimer-images/privacy-lock.png'
import PrivacyLockImage2x from 'static/images/free-and-privacy-disclaimer-images/privacy-lock-2x.png'

import FreeChargeImage from 'static/images/free-and-privacy-disclaimer-images/free-charge.png'
import FreeChargeImage2x from 'static/images/free-and-privacy-disclaimer-images/free-charge-2x.png'

import * as S from './styles'

interface FreeAndPrivacyDisclaimerModalProps {
  onClose: () => void
}

const corporatePrivacyText = (
  <Typography variant='content2'>
    Pode ficar completamente tranquilo(a), seus dados <b>não são compartilhados</b> com o RH da sua empresa ou com o seu gestor.
  </Typography>
)

const enterprisePrivacyText = (
  <Typography variant='content2'>
    Pode ficar completamente tranquilo(a), seus dados <b>não são compartilhados</b> e estão 100% seguros.
  </Typography>
)

export const FreeAndPrivacyDisclaimerModal = ({ onClose }: FreeAndPrivacyDisclaimerModalProps): JSX.Element => {
  const { isCorporate } = usePatientPlanType()
  const { isMobile } = useDimensions()

  return (
    <ModalGeneric
      modalTitle="Na Telavita, não tem preocupação porque…"
      onCloseModal={onClose}
      type='large'
    >
      <S.Container>
        <S.Grid isMobile={isMobile}>
          <S.GridItem isMobile={isMobile}>
            <picture>
              <source 
                media='(min-width: 768px)'
                srcSet={PrivacyLockImage}
              />
              <img 
                loading='lazy'
                src={PrivacyLockImage2x} 
                alt="Duas pessoas representando uma teleconsulta onde um ícone de cadeado aparece, simbolizando a privacidade da consulta" 
              />
            </picture>
            <Typography variant='content1' weight='bold'>
              O que você compartilha na sessão é sigiloso
            </Typography>
            {isCorporate ? corporatePrivacyText : enterprisePrivacyText}
          </S.GridItem>

          <S.GridItem isMobile={isMobile}>
            <picture>
              <source 
                media='(min-width: 768px)'
                srcSet={FreeChargeImage} 
              />
              <img
                loading='lazy'
                src={FreeChargeImage2x}
                alt="Uma mulher faz sinal de coração com as mãos e um ícone de cifrão com um X aparece para simbolizar a gratuidade da consulta" 
              />
            </picture>
            <Typography variant='content1' weight='bold'>
              Não tem custo, nem coparticipação
            </Typography>
            <Typography variant='content2'>
              Aproveite seu benefício, ele é <b>100% gratuito</b>. Fazendo 1 consulta por semana, você estará economizando no mínimo R$ 400 ao mês*.
            </Typography>
            <Typography variant='content3' italic>
              * Valor que você gastaria se fizesse terapia no particular.
            </Typography>
          </S.GridItem>
          
        </S.Grid>
        <Button
          onClick={onClose}
          uppercase={false}
          variant='contained'
        >
          Entendi
        </Button>
      </S.Container>
    </ModalGeneric>
  )
}